import React, {useEffect, useState, useCallback } from 'react';
import { IPreparedSelectProps, SelectBase, ISelectProps, ISelectOptions } from 'react-ocean-forms-bootstrap';
import { withField } from 'react-ocean-forms';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';

type BaseProps = Omit<ISelectProps, 'options'>;

interface StatusSelectProps extends BaseProps {
  selectAll?: boolean;
  disabled?: boolean;
  getList(): Promise<ISelectOptions>;

}

// type StatusSelectProps = BaseStatusSelectProps & IFieldComponentProps & IBaseFieldProps & IValidatedComponentProps;

/**
 * TODO benötigt die viewMode info damit es unterschiedlich angezeigt werden kann bei Suche und Anlage
 *
 * @author Jungwirth
 */
export const BaseStatusSelect: React.FC<StatusSelectProps> = (props: Readonly<StatusSelectProps>): JSX.Element => {
  const { handleChange, selectAll, getList, field, disabled, ...selectProps } = props;
  const [data, setData] = useState<ISelectOptions>([]);
  const [isLoading, setIsLoading] = useState(false);

  const baseProps = {
    ...selectProps,
    field,
  };

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      setIsLoading(true);
      const result = await getList();
      setData(result);      
      setIsLoading(false);
    };
    fetchData();
  },[getList]);

  const AllButton: React.FC = () => {
    if(selectAll) {
      return (
        <Button
          color="primary"
          disabled={disabled}
          onClick={() => {
            const filtered = data.map(e => {
              // @ts-ignore
              if (!e.isDisabled) {
                return e;
              }
            });
            field.onChange({
              target: {
                value: !filtered.every(e => e === undefined) ? [...filtered] : [],
              },
            });
          }}
        >
          <FormattedMessage id="button_all" />
        </Button>)
    }
    return null;
  };
  
  const renderSelect = useCallback((preparedProps: IPreparedSelectProps): JSX.Element => {
    // https://github.com/JedWatson/react-select/issues/3066
    const value = preparedProps.value ? preparedProps.value : null;
    return (
      <Select
        {...preparedProps}
        value={value}
        classNamePrefix="ocean"
      />
    );
  },[]);

  return (
    <SelectBase
      {...baseProps}
      loading={isLoading}
      options={data}
      renderSelect={renderSelect}
      suffix={<AllButton />}
    />
  );
};

BaseStatusSelect.displayName = 'StatusSelect';

export const StatusSelect = withField(BaseStatusSelect);
